const MAP = {
  queued: ["Queued", "#A8A29E"],
  generating: ["Researching", "#3B82F6"],
  verifying: ["Verifying", "#3B82F6"],
  fact_checking: ["Fact-checking", "#3B82F6"],
  waiting: ["Waiting in queue", "#A8A29E"],
  fixing: ["Fixing", "#3B82F6"],
  review: ["In Review", "#F59E0B"],
  selecting: ["Tick Been There", "#B08E3A"],
  failed: ["Failed", "#EF4444"],
  published: ["Published", "#10B981"],
  ready: ["Ready · Not published", "#0284C7"],
  ok: ["Live", "#10B981"],
  flagged: ["Flagged", "#F59E0B"],
};

export const StatusBadge = ({ status, testId }) => {
  const [label, color] = MAP[status] || [status, "#A8A29E"];
  const pulse = ["generating", "verifying", "fact_checking", "fixing"].includes(status);
  return (
    <span
      data-testid={testId}
      className="inline-flex items-center gap-1.5 rounded-sm px-2.5 py-0.5 text-[11px] font-mono-ui uppercase tracking-wider border"
      style={{ color, borderColor: `${color}55`, background: `${color}14` }}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${pulse ? "animate-pulse" : ""}`} style={{ background: color }} />
      {label}
    </span>
  );
};

export const kitStatus = (k) => (k.product?.published ? "published" : (k.finalised || k.ready) && !k.bespoke ? "ready" : k.status);
